export default __webpack_public_path__ + "static/media/stickerPeru.d3066936.webp";